import { Routes, Route, Navigate } from "react-router-dom";
import PersistLogin from "./components/PersistLogin";
import Login from "./features/auth/Login";
import Cognito from "./features/auth/Cognito";
import Layout from "./components/Layout";
import LandingPage from "./features/landing/LandingPage";
import ProgressPage from "./features/progress/ProgressPage";
import AssignmentsPage from "./features/assignments/AssignmentsPage";
import LessonsPage from "./features/lessons/LessonsPage";
import MasteryPage from "./features/mastery/MasteryPage";
import ChatPage from "./features/chat/ChatPage";
import MockupLayout from "./mockups/_layout/MockupLayout";
import MockupIndex from "./mockups/pages/MockupIndex";
import OnboardingPage from "./mockups/pages/OnboardingPage";
import DashboardPage from "./mockups/pages/DashboardPage";
import ChallengePage from "./mockups/pages/ChallengePage";

const MOCKUPS_ENABLED = process.env.REACT_APP_ENABLE_MOCKUPS === "true";

const App = () => {
  return (
    <>
      <Routes>
        {/* Mockup routes — no auth, no API */}
        {MOCKUPS_ENABLED && (
          <Route element={<MockupLayout />}>
            <Route path="mockups" element={<MockupIndex />} />
            <Route path="onboarding" element={<OnboardingPage />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="challenge" element={<ChallengePage />} />
          </Route>
        )}

        <Route path="callback" element={<Cognito />} />
        <Route path="login" element={<Login />} />
        <Route element={<PersistLogin />}>
          <Route element={<Layout />}>
            <Route index element={<LandingPage />}></Route>
            <Route path="progress" element={<ProgressPage />}></Route>
            <Route path="tasks" element={<AssignmentsPage />}>
              <Route index element={<AssignmentsPage />}></Route>
              <Route path=":taskId" element={<AssignmentsPage />}></Route>
            </Route>
            <Route path="lessons" element={<LessonsPage />}></Route>
            <Route path="mastery" element={<MasteryPage />}></Route>
            <Route path="problems" element={<ChatPage />}>
              <Route index element={<ChatPage />}></Route>
              <Route path=":dialogId" element={<ChatPage />}></Route>
            </Route>
            <Route path="*" element={<Navigate to={"/"} replace />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
};

export default App;
